import { useTranslation } from "react-i18next";
import AmbientField from "@/components/AmbientField";

// Экран загрузки: разряд.
//
// Знак и ветви — та же молния, что бьёт по карте, поэтому геометрия здесь
// такая же по духу: ствол и ветви поколениями, растущие ОТ него и никогда не
// сходящиеся обратно. Так ведёт себя настоящий разряд.
//
// Поле света монтируем отдельно: этот экран закрывает приложение собой и в его
// дерево не попадает. Тот же приём, что у замка кода-пароля, — иначе загрузка
// осталась бы единственной плоской поверхностью продукта.

// Ствол знака — замкнутый контур молнии, он же холодный логотип.
const GLYPH = "M112,20 L76,106 L100,106 L86,180 L126,92 L102,92 Z";
// Разряд идёт по ломаной внутри знака: сверху вниз, как настоящий.
const TRUNK = "112,20 76,106 100,106 86,180";

// Заряд стягивается к знаку от краёв кадра. Задержки разводят нити во времени,
// иначе они читаются как одна пульсация, а не как сходящийся заряд.
const CHARGE = [
  { points: "4,52 34,60 26,74 58,84", width: 1.1, delay: "0ms" },
  { points: "196,132 168,124 176,110 144,100", width: 1.1, delay: "-160ms" },
  { points: "150,6 138,32 122,26 112,50", width: 0.9, delay: "-320ms" },
  { points: "52,194 66,168 82,174 90,152", width: 0.9, delay: "-90ms" },
];

// Ветви растут из узлов ствола. Поколение задаёт и толщину, и очередь вспышки.
const BRANCHES = [
  { points: "94,64 66,54 72,42", gen: 1 },
  { points: "84,86 118,78 114,64", gen: 1 },
  { points: "100,106 132,116 126,130", gen: 1 },
  { points: "92,142 62,150 68,164", gen: 1 },
  { points: "66,54 44,44 46,32", gen: 2 },
  { points: "118,78 140,68 138,56", gen: 2 },
  { points: "132,116 154,124 150,136", gen: 2 },
  { points: "62,150 40,158 44,170", gen: 2 },
  { points: "46,32 32,24", gen: 3 },
  { points: "138,56 152,46", gen: 3 },
  { points: "150,136 166,144", gen: 3 },
  { points: "44,170 30,178", gen: 3 },
];

const GEN = {
  1: { width: 1.7, className: "lp-splash-b1" },
  2: { width: 1, className: "lp-splash-b2" },
  3: { width: 0.55, className: "lp-splash-b3" },
};

// leaving — такт доигран, экран уступает место приложению. Гасим СОДЕРЖИМОЕ,
// а фон оставляем: он того же цвета, что и фон приложения, поэтому подмена
// читается как растворение разряда, а не как смена экрана.
const SplashScreen = ({ leaving = false }) => {
  const { t } = useTranslation();
  const label = t("common.loading_wallet");

  return (
    // role="status" вместо простого div: экран должен объявлять себя вслух, а
    // не оставлять скринридер в тишине на несколько секунд.
    <div
      className={`lp-splash${leaving ? " lp-splash--leaving" : ""}`}
      role="status"
      aria-busy={!leaving}
      aria-label={label}
    >
      <AmbientField />

      <div className="lp-splash-mark" aria-hidden="true">
        <svg viewBox="0 0 200 200" fill="none">
          {CHARGE.map(({ points, width, delay }) => (
            <polyline
              key={points}
              className="lp-splash-charge"
              points={points}
              pathLength="100"
              strokeWidth={width}
              style={{ animationDelay: delay }}
            />
          ))}

          <circle className="lp-splash-shock" cx="100" cy="100" r="46" />

          <path className="lp-splash-cold" d={GLYPH} />

          {/* Ореол: широкий и размытый, даёт свечение вокруг разряда */}
          <polyline
            className="lp-splash-hot lp-splash-halo"
            points={TRUNK}
            pathLength="100"
            strokeWidth="9"
          />

          {BRANCHES.map(({ points, gen }) => (
            <polyline
              key={points}
              className={GEN[gen].className}
              points={points}
              pathLength="100"
              strokeWidth={GEN[gen].width}
            />
          ))}

          {/* Ствол и раскалённая нить внутри него */}
          <polyline className="lp-splash-hot" points={TRUNK} pathLength="100" strokeWidth="2.6" />
          <polyline className="lp-splash-core" points={TRUNK} pathLength="100" strokeWidth="0.9" />
        </svg>
      </div>

      <div className="lp-splash-word">LightPay</div>
      <div className="lp-splash-status">{label}</div>
    </div>
  );
};

export default SplashScreen;
